/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefOrganizationData } from '../../models/api-def-organization-data';

export interface OrganizationsGetAllByUserId$Params {
}

export function organizationsGetAllByUserId(http: HttpClient, rootUrl: string, params?: OrganizationsGetAllByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiDefOrganizationData>>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetAllByUserId.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiDefOrganizationData>>;
    })
  );
}

organizationsGetAllByUserId.PATH = '/organizations';
